'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { GenericEvents } from 'product/types/GenericEvents'
import { ProductDisclaimer } from 'product/types/Product'
import { type ReactNode, useEffect, useMemo } from 'react'

import {
	CONTEXTUAL_MESSAGE_TYPE,
	ContextualMessage,
} from '@fukku/contextual-message'
import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

import styles from './DisclaimerMessage.module.scss'

const sizeDisclaimerKey: Record<ProductDisclaimer, string> = {
	[ProductDisclaimer.UP_DISCLAIMER]:
		'product.sizeSelector.smallSizing.helpmessage',
	[ProductDisclaimer.DOWN_DISCLAIMER]:
		'product.sizeSelector.bigSizing.helpmessage',
	[ProductDisclaimer.SIZEGUIDE_DISCLAIMER]:
		'product.sizeSelector.helpSize.sizeguide.text',
	[ProductDisclaimer.MATERNITY_DISCLAIMER]:
		'product.sizeSelector.helpSize.maternity.text',
}

export function DisclaimerMessage({
	type,
}: {
	readonly type: ProductDisclaimer
}): ReactNode {
	const { t } = useLabels()
	const key = useMemo(() => sizeDisclaimerKey[type], [type])

	useEffect(() => {
		sendGenericEvent(GenericEvents.SHOW_DISCLAIMER_SIZE)
	}, [])

	return (
		<ContextualMessage
			className={styles.sheetDisclaimer}
			type={CONTEXTUAL_MESSAGE_TYPE.INFO}
			message={t(key)}
		/>
	)
}
